












































import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Users extends Vue {
    dialog: boolean = false;
    toRemove: any = null;

    async mounted() {
      await this.$store.dispatch('$destinations/select', this.$route.params.did);
      await this.$store.dispatch('$users/reload', this.$route.params.did);
    }

    async askRemove(user: any) {
      this.toRemove = user;
      this.dialog = true;
    }

    async remove() {
      console.log("remove user", this.toRemove);
      await this.$store.dispatch('$users/remove', this.toRemove);
      this.toRemove = null;
      this.dialog = false;
    }
}
